module.exports = __webpack_public_path__ + "static/media/5@1280w.68057791.jpg";